import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueGtag from 'vue-gtag';
import loadGmapApi from '@/libraries/google/LoadGmapApi';
import auth from '@websanova/vue-auth/dist/v2/vue-auth.esm.js';
// import authBearer      from '@websanova/vue-auth/drivers/auth/bearer.js';
// import httpAxios       from '@websanova/vue-auth/drivers/http/axios.1.x.js';
// import routerVueRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x.js';
import driverAuthBearer from '@websanova/vue-auth/dist/drivers/auth/bearer.esm.js';
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js';
import { ROUTES } from '@/app/shared/utils/constants';

// Setup Vue Auth using the Axios library
export const setAuthenticationConfig = (
    rolesKey = 'acl',
    tokenDefaultKey = 'cityhub_auth_token',
    tokenImpersonateKey = 'cityhub_auth_token_impersonate',
    rememberKey = 'cityhub_auth_remember',
    staySignedInKey = 'cityhub_auth_stay_signed_in'
) => {
    Vue.use(auth, {
        plugins: {
            http: Vue.axios,
            router: Vue.router
        },
        drivers: {
            auth: driverAuthBearer,
            http: driverHttpAxios,
            router: driverRouterVueRouter
        },
        options: {
            rolesKey, // The default field to check against on the user object when using "auth meta" or $auth.check()
            rememberKey,
            staySignedInKey,
            tokenDefaultKey,
            tokenImpersonateKey,
            stores: ['storage', 'cookie'],
            notFoundRedirect: { name: 'portal.home' },
            authRedirect: { name: 'portal.login' },
            forbiddenRedirect: { name: 'portal.forbidden' },
            notFoundRedirect: { name: 'portal.notfound' },
            registerData: {
                url: '/auth/register',
                method: 'POST',
                redirect: '/portal/login',
                autoLogin: false // If the autoLogin is enabled it will subsequently trigger a login call.
            },
            loginData: {
                url: '/auth/login',
                method: 'POST',
                redirect: '/',
                fetchUser: true, // Specify whether to fetch a user or not after a request
                staySignedIn: true // Specify whether the token data stored will be long lived or not. Meaning does it expire after the browser is closed or not.
            },
            logoutData: {
                url: '/auth/logout',
                method: 'POST',
                redirect: '/',
                makeRequest: true // Specify whether to trigger an API call first.
            },
            fetchData: {
                url: '/auth/profile',
                method: 'GET',
                enabled: true
            },
            refreshData: {
                url: '/auth/refresh',
                method: 'GET',
                interval: 30, //(in minutes) This is used primarily to keep tokens alive while a user is active on the app
                redirect: '/',
                enabled: true
            }
        }

        // 	// tokenDefaultName: tokenDefaultName,
        // 	// tokenStore: ['vuex', 'localStorage', 'cookie'],
        // 	// tokenType: 'Bearer',
        // 	// rolesVar: rolesVar,
    });
};

export function setConfigAxios(config, store, router) {
    const urlDisableLoading = [
        /\/auth\/refresh$/,
        /\/gateway\/address\/search/,
        /\/gateway\/proxy$/,
        /\/job\/\d+$/,
        /\/job\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
        /\/server\/ogc\/ows\/\d+\?/,
        /\/front\/map\/layers$/,
        /meubairro\/occurrences\/search\/code\/\w+$/,
        /meubairro\/occurrences\/store\/search\/user$/,
        /pim\/front\/mp\/object\/\d+$/,
        /pim\/\w+\/search/,
        /pu\/front\/allotments\/data\/simplified\/\w+\/\w+$/,
        /pu\/epaper\/sgu\/process?/,
        /cosec\/search\/\w+$/,
        /cosec\/feature\/\w+\/\d+$/,
        /gim\/parishinterventions\/works\/search\/code\/\d+$/,
        /gim\/municipalinterventions\/works\/search\/code\/\d+$/,
        /tax\/gestao\/billing\/invoices\/calculator$/,
        /\/lookup\/\S+$/,
        // /\/gestao\/\w+\/resources/,
        /occurrences\/search\/user/,
        /cosi\/gestao\/unities\/search/,
        /cosi\/central\/communications\/search/,
        /cosi\/central\/shifts\/search/,

        /epl\/front\/search\/\w+$/,
        /gu\/urbanplanning\/search\/\w+$/,
        /os\/front\/sidebar\/page\/[a-zA-Z0-9_-]+$/,
        /genericapplication\/[a-zA-Z0-9_-]+\/front$/,
        /genericapplication\/[a-zA-Z0-9_-]+\/front\/[a-zA-Z0-9_-]+\/sidebar\/page\/[a-zA-Z0-9_-]+$/,
    ];

    axios.interceptors.request.use(
        request => {
            if (typeof axios.defaults.loading == 'undefined' && !urlDisableLoading.find(e => e.test(`${request.url}`))) {
                store.dispatch('setLoading', true);
            }
            return request;
        },
        error => {
            if (typeof axios.defaults.loading == 'undefined') {
                store.dispatch('setLoading', false);
            }

            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        response => {
            if (typeof axios.defaults.loading == 'undefined') {
                store.dispatch('setLoading', false);
            }
            return response;
        },
        error => {
            if (typeof axios.defaults.loading == 'undefined') {
                store.dispatch('setLoading', false);
            }
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            // if(!redirectMaintenceMode(error, router)) {
            //     return Promise.reject(error);
            // }
            return Promise.reject(error);
        }
    );

    axios.defaults.crossDomain = true;
    axios.defaults.baseURL = config.API_URL;
    axios.defaults.proxyURL = config.PROXY_URL;
    Vue.use(VueAxios, axios);
}

export const redirectMaintenceMode = (error, router) => {
    if (error?.response?.status == 503 && router.currentRoute != ROUTES.MAINTENANCE) {
        router.push({ name: ROUTES.MAINTENANCE });
        return true;
    }
    return false;
};

// Setup Google Analytics
export const setGoogleConfig = (config, router = null, appName = null, debug = false) => {
    if (config) {
        let mapsConfig = config?.g_maps_api ?? {};
        let analyticsConfig = config?.g_analytics_api ?? {};
        if (analyticsConfig) {
            if (!debug) {
                let id = analyticsConfig.id;
                // Google Analytics
                if (id) {
                    Vue.use(
                        VueGtag,
                        {
                            config: {
                                id: id
                            },
                            deferScriptLoad: true,
                            appName: appName
                        },
                        router
                    ); // Enable auto-tracking

                    // Google Tag Manager (gtag.js)
                    if (analyticsConfig.gtag) {
                        // Setting dataLayer & gtag to window because I'm using a custom code text field in a tag management system
                        window.dataLayer = window.dataLayer || [];
                        window.gtag =
                            window.gtag ||
                            function gtag() {
                                dataLayer.push(arguments);
                            };
                        gtag('js', new Date());
                        gtag('config', id);

                        // Set initial gtag/js?id=<first ID> script to <head>
                        let script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.async = true;
                        script.src = '//www.googletagmanager.com/gtag/js?id=' + id;
                        document.getElementsByTagName('head')[0].appendChild(script);
                    }
                }
            }
        }
        if (mapsConfig) {
            if (mapsConfig.key) {
                return new Promise((resolve, reject) => {
                    try {
                        window.vueGoogleMapsInit = resolve;
                        loadGmapApi(mapsConfig, mapsConfig.loadCn);
                    } catch (err) {
                        reject(err);
                    }
                });
            }
        }
    }
};
